import React from "react";

const UploadPhoto = () => {
  return (
    <svg viewBox="0 0 18 16.071">
      <g transform="translate(-31.578 -78.949)">
        <path
          d="M32.864,78.949a1.285,1.285,0,0,0-1.286,1.286V90.52a1.285,1.285,0,0,0,1.286,1.286h6.577a5.721,5.721,0,0,1-.148-1.286,6.017,6.017,0,0,1,.038-.643H33.507v-4.5l1.471-1.472a1.555,1.555,0,0,1,2.2,0L40.4,87.125a5.782,5.782,0,0,1,7.9-1.416V80.235a1.285,1.285,0,0,0-1.286-1.286Zm12.214,1.929a1.286,1.286,0,1,1-1.286,1.286A1.285,1.285,0,0,1,45.078,80.878Zm0,5.143a4.5,4.5,0,1,0,4.5,4.5A4.5,4.5,0,0,0,45.078,86.021Zm0,1.929a.643.643,0,0,1,.643.643v1.286h1.286a.643.643,0,0,1,0,1.286H45.721v1.286a.643.643,0,0,1-1.286,0V91.163H43.15a.643.643,0,0,1,0-1.286h1.286V88.592A.643.643,0,0,1,45.078,87.949Z"
          transform="translate(0)"
        />
      </g>
    </svg>
  );
};

export default UploadPhoto;
